import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../loaders/SkeletonTicketList";
import {
  DeleteLayhoutHeader,
  getHeaderFilters,
  getHeadersList,
  getHeadersListCancelToken
} from "../../services/LayoutHeaderServices";
import { handleTableScroll } from "../../utils/commonFunction";
import { RenderHeaderTypeMethod } from "../../utils/CommonGroupingItem";
import {
  LayoutHeaderStatus,
  RenderWebsiteBrandTemplate
} from "../../utils/CommonStatusItems";
import { TABLE_ROWS_PER_PAGE } from "../../utils/Constants";
import PermissionsGate from "../../utils/permissionGate";
import Tablefilter from "../common/Tablefilter";

function LayoutHeaders() {
  const [search, setSearch] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [status, setStatus] = useState({ arr: [], checkObj: {} });
  const [searchStatusCheck, setSearchStatusCheck] = useState({});
  const [updateData, setUpdateData] = useState(true);
  const [headerData, setHeaderData] = useState([]);
  const [loading, setloading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortkey, setSortKey] = useState("");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [filterData, setFilterData] = useState({
    status: [],
  });

  useEffect(() => {
    handleTableScroll();
  }, [loading]);

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $(".rdt_TableCell").css("z-index", 0);
        $(this).parents(".rdt_TableCell").css("z-index", 22);
      });
    });
  });
  useEffect(() => {
    const storedFilters = JSON.parse(localStorage.getItem("filterStateHeader"));
    if (storedFilters) {
      setStatus(storedFilters.status);
      setFilterData(storedFilters.filterData);
    }
  }, []);
  useEffect(() => {
    const filterState = {
      status,
      filterData,
    };
    localStorage.setItem("filterStateHeader", JSON.stringify(filterState));
  }, [status, filterData]);
  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $(".rdt_TableCell").css("z-index", 0);
        $(this).parents(".rdt_TableCell").css("z-index", 22);
      });
    });
  });
  useEffect(() => {
    const cancelTokenSources = [];
    const getHeadersList = async () => {
      setloading(true);
      cancelTokenSources.forEach((source) => {
        source.cancel("New request made");
      });

      const source = axios.CancelToken.source();
      // setCancelTokenSources([...cancelTokenSources, source]);
      cancelTokenSources.push(source);

      const headersData = {
        page: page,
        perPage: perPage,
        keyval: sortkey,
        sort: sortOrder,
        search: search,
        exportStatus: false,
        viaStatus: status.arr,
      };

      try {
        const res = await getHeadersListCancelToken(headersData, source.token);
        setHeaderData(res?.data?.data?.data);
        setTotalRows(res.data?.data?.total);
        setPerPage(res.data?.data?.perPage);
        if (res.status == 200) {
          setloading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    };

    getHeadersList();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("Component unmounted");
      });
    };
  }, [
    page,
    perPage,
    sortOrder,
    sortkey,
    search,
    status,
    searchStatusCheck,
    updateData,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getHeaderFilters();
        setFilterData({
          ...res.data,
          status: res.data.headerStatus ? res.data.headerStatus : [],
        });
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    fetchData();
  }, []);

  usePermissionGuardRedirect(['wbslnheadersview']);

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setDebouncedTerm(value);
  };

  const resetFilter = () => {
    setStatus({ arr: [], checkObj: {} });
    setSearchStatusCheck({});
    setSearch("");
    setDebouncedTerm("");
  };

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  const handleSort = (column, sortDirection) => {
    setSortKey(column.sortField);
    setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteLayhoutHeader({ SliderID: id })
          .then((res) => {
            Swal.fire("Deleted!", "Layout Header has been deleted.", "success");
            setUpdateData(!updateData);
          })
          .catch((error) => console.log(error));
      }
    });
  };

  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "SliderName",
      sortField: "SliderName",
      sortable: true,
      cell: (row) => (
        <PermissionsGate scopes={["wbslnheadersedit"]} RenderError={() => (<p>{row?.SliderName ? row.SliderName : ""}</p>)}>
          <Link
            title={row.SliderName}
            className="as-text-blue curser feature-name"
            to={`/websiteManagement/layout_navigation/header/header_information/open/${row.SliderID}`}
          >
            <span className="textLimit100">
              {row.SliderName ? row.SliderName : ""}{" "}
            </span>
          </Link>
        </PermissionsGate>
      ),
    },
    {
      name: "Type",
      selector: "IsDefault",
      sortField: "IsDefault",
      sortable: true,
      cell: (row) =>
        row.IsDefault
          ? RenderHeaderTypeMethod(row.IsDefault, "IsDefault").html
          : "-",
    },
    {
      name: "Assigned Brand Templates",
      selector: "brandTemplete",
      sortField: "brandTemplete",
      sortable: false,
      cell: (row) => {
        if (row.brandTemplete.length) {
          return (
            <>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {row?.brandTemplete.map((d, i) => (
                  <React.Fragment key={i}>
                    {RenderWebsiteBrandTemplate(d?.brand_name).html}
                  </React.Fragment>
                ))}
              </div>
            </>
          );
        } else {
          return "-";
        }
      },
    },
    {
      name: "Status",
      selector: "SliderStatus",
      sortField: "SliderStatus",
      sortable: true,
      cell: (row) =>
        row.SliderStatus?.toString()
          ? LayoutHeaderStatus(row.SliderStatus).html
          : "-",
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <PermissionsGate scopes={['wbslnheadersedit']} RenderError={() => (
              <button className="btn btn-primary rounded-circle" disabled>
                <i className="fal fa-folder-open"></i>
              </button>
            )}>

            <Link
              className="btn btn-primary rounded-circle"
              to={`/websiteManagement/layout_navigation/header/header_information/open/${row.SliderID}`}
              title="Open"
              >
              <i className="fal fa-folder-open"></i>
            </Link>
            </PermissionsGate>
            <PermissionsGate scopes={['wbslnheadersdelete']} RenderError={() => (
              <button className="btn btn-danger rounded-circle" disabled>
                <i className="fal fa-trash-alt"></i>
              </button>
            )}>

            <button
              className="btn btn-danger rounded-circle"
              onClick={() => handleDelete(row.SliderID)}
              >
              <i className="fal fa-trash-alt"></i>
            </button>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const exportData = (fileType, fileName) => {
    let data = [];
    const header = ["Name", "Type", "Assigned Brand Templates", "Status"];
    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });

    const headerData = {
      page: page,
      perPage: perPage,
      keyval: sortkey,
      sort: sortOrder,
      search: search,
      exportStatus: true,
      viaStatus: status.arr,
    };

    getHeadersList(headerData)
      .then((res) => {
        data = res.data.data;
        data = data?.map((row) => ({
          // ...row,
          Name: row?.SliderName || "",
          Type: row.IsDefault ? row.IsDefault : "-",
          "Assigned Brand Templates": row?.brandTemplete?.map((d, i) => d?.brand_name).join(",") || "-",
          Status: row?.SliderStatus !== null ? LayoutHeaderStatus(row.SliderStatus).text : "-",
        }));

        if (fileType === "csv") {
          const csvString = Papa.unparse(data, { fields: header});
          const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
  
          const blobURL = window.URL.createObjectURL(blob);
  
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
          anchor.click();
  
          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = data.map((row) => {
            const obj = {};
            header.map((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = data.map((row) => {
            return [
              row["Name"],
              row["Type"],
              row["Assigned Brand Templates"],
              row["Status"]
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              // valign: "center",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      })
      .catch((err) => {
        Swal.close();
        console.log(err);
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [debouncedTerm]);

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
      <div className="custom-table-div filter-search-icon card card-table-custom program-table">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      <input
                        type="search"
                        className=""
                        placeholder="Search"
                        aria-controls="assessment-table-main"
                        onChange={handleSearchFilter}
                        value={debouncedTerm}
                      />
                    </label>
                    <div className="filter-eff filter-data-btn">
                      <button className="filter-buttons">
                        <i className="fal fa-filter"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner filter-custom-new`}>
                    <Tablefilter
                      filterName="Status"
                      optionArr={filterData?.status}
                      state={status}
                      setState={setStatus}
                      renderLabelFunction={LayoutHeaderStatus}
                    />
                  </div>
                </div>
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={resetFilter}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("xlsx", "Headers List");
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", "Headers List");
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", "Headers List");
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="search-filter-div-right">
            <div className=" filter-search-bar-blk">
              <div className="add-ticket-blk button-reset dropdown-comman">
                <PermissionsGate scopes={['wbslnheadersadd']} RenderError={() => (
                  <button className="btn btn-primary" disabled>
                    <i className="fal fa-plus"></i>Create New
                  </button>
                )}>

                <Link
                  to={`/websiteManagement/layout_navigation/header/header_information/create`}
                  >
                  <button
                    type="button"
                    className="btn btn-primary"
                    title="Create new"
                    >
                    <i className="fal fa-plus"></i>Create New
                  </button>
                </Link>
                </PermissionsGate>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          paginationDefaultPage={page}
          progressPending={loading}
          data={headerData}
          progressComponent={<SkeletonTicketList />}
          defaultSortField={sortkey}
          defaultSortAsc={false}
          columns={columns}
          pagination={true}
          // noDataComponent={Str.noRecord}
          onSort={handleSort}
          sortServer
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          highlightOnHover={false}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
      </div>
    </div>
  );
}

export default LayoutHeaders;
